import { Icon } from "@fluentui/react";
import { getFileTypeIconProps } from "@fluentui/react-file-type-icons";
import { notification } from "antd";
import React, { ReactNode, memo, useEffect } from "react";
import { useSelector } from "react-redux";
import { JsxElement } from "typescript";

export const openNotification = (message: string, description: any, data?: any) => {
  switch (message) {
    // Edit Document
    case "Edit Document":
      notification.open({
        message: (
          <div className="px-3">
            <b>{message}</b>
          </div>
        ),
        description: (
          <div className="notification px-3">
            Document <b>{data.name}</b> (ID: {data.id}) updated successfully
          </div>
        ),
      });
      break;
    // Start Translation
    case "Start Translation":
      notification.open({
        message: (
          <div className="px-3">
            <b>{message}</b>
          </div>
        ),
        description: (
          <div className="notification px-3">
            Translation of the document <b>{data.name}</b> (ID: {data.id}) is starting
          </div>
        ),
      });
      break;
    // Stop Translation
    case "Stop Translation":
      notification.open({
        message: (
          <div className="px-3">
            <b>{message}</b>
          </div>
        ),
        description: (
          <div className="notification px-3">
            Translation of the document{" "}
            <b>
              ID: {data} / {data.ID}
            </b>
            is stopping
          </div>
        ),
      });
      break;
    // Delete Document
    case "Delete Document":
      notification.open({
        message: (
          <div className="px-3">
            <b>{message}</b>
          </div>
        ),
        description: (
          <div className="notification px-3">
            Document <b>{data.name}</b> (ID: {data.data.id} / {data.ID}) deleted successfully
          </div>
        ),
      });
      break;
    default:
      notification.open({
        message: (
          <div className="px-3">
            <b>{message}</b>
          </div>
        ),
        description: <div className="notification px-3">{description}</div>,
      });
  }
};
